import React from 'react';
import {
  shape,
  string,
  bool,
  number,
  arrayOf
} from 'prop-types';
import { CheckNearByStore } from './CheckNearByStore';

const StoreUnavailable = ({
  itemId,
  location,
  isShipToHomeEligible,
  isAppliance
}) => (
  <>
    <div>
      <span>This item is </span>
      <span className="u__text--danger">unavailable</span>
      <span>{` at ${location.storeName}`}</span>
    </div>
    {!isAppliance && (
      <div className="fulfillment__sub-title">
        <CheckNearByStore
          itemId={itemId}
          isShipToHomeEligible={isShipToHomeEligible}
        >
          Change nearby stores
        </CheckNearByStore>
      </div>
    )}
  </>
);

StoreUnavailable.propTypes = {
  itemId: string.isRequired,
  isShipToHomeEligible: bool,
  isAppliance: bool,
  location: shape({
    isAnchor: bool,
    storeName: string,
    inventory: shape({
      quantity: number,
      isInStock: bool,
      isLimitedQuantity: bool,
      isBackordered: bool
    })
  }).isRequired
};

StoreUnavailable.defaultProps = {
  isShipToHomeEligible: false,
  isAppliance: false

};

export { StoreUnavailable };
